module.exports = __webpack_public_path__ + "img/logoR2.2421b57d.png";